import {
  ref, Ref, onMounted, computed, reactive,
} from '@vue/composition-api'
import ability from '@/plugins/acl/ability'
import {
  fetchAggregationContainers,
  AggregationContainerAttrs,
} from '@/api/v2/report/AggregationContainer'
import useCurrentData from '@/views/composable/useCurrentData'
import { useDateRange } from './useDateRange'

export interface NavMenuItem {
  title: string
  to: {
    name: string
    params: Record<string, string | number>
  },
  resources?: string[],
  resource?: string
  action: string
}

export function useAggregationContainerNavMenuItems() {
  const { currentClub } = useCurrentData()
  const { dateRange } = useDateRange()

  const containers: Ref<AggregationContainerAttrs[]> = ref([])
  const loading: Ref<boolean> = ref(false)
  const error: Ref<Error | null> = ref(null)

  const query = reactive({
    start_date: dateRange.value[0],
    end_date: dateRange.value[1],
  })

  const canAccess = computed(() => {
    return ability.can('manage', 'report') || ability.can('read', 'report:aggregation_containers')
  })

  const navMenuItems = computed(() => {
    return containers.value.map(c => ({
      title: c.name,
      to: {
        name: 'report-aggregation-container',
        params: { club_slug: currentClub.value?.slug, id: c.id },
        query,
      },
      resources: ['report', 'report:aggregation_containers'],
      action: 'read',
    }))
  })

  // NOTE: 再読み込み用にも使えるように reload として返却
  async function reload(): Promise<void> {
    if (!canAccess.value) return

    loading.value = true
    error.value = null

    try {
      containers.value = await fetchAggregationContainers()
    } catch (e) {
      error.value = e as Error
    } finally {
      loading.value = false
    }
  }

  // マウント時に一度ロード
  onMounted(reload)

  return {
    loading,
    error,
    navMenuItems,
    reload,
  }
}
